import * as React from "react";
const SvgProfilerOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M2 18v-.8q0-.825.425-1.55t1.175-1.1q1.5-.75 3.113-1.15t3.312-.4q.4 0 .688.287.287.288.287.763a.9.9 0 0 1-.287.675.96.96 0 0 1-.688.275q-1.775 0-3.2.45t-2.325.9a.97.97 0 0 0-.5.85v.8h6q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 10 20H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18m15 3.025q-.2 0-.4-.05a1.1 1.1 0 0 1-.375-.175l-3-1.75a1.4 1.4 0 0 1-.537-.538 1.5 1.5 0 0 1-.188-.737V14.25q0-.4.188-.738.187-.337.537-.537l3-1.75a1.1 1.1 0 0 1 .375-.175q.2-.05.4-.05t.387.063.363.162l3 1.75q.35.2.55.537.2.338.2.738v3.525q0 .4-.2.738a1.5 1.5 0 0 1-.55.537l-3 1.75q-.175.1-.363.162a1.2 1.2 0 0 1-.387.063M10 12q-1.65 0-2.825-1.175T6 8t1.175-2.825T10 4t2.825 1.175T14 8t-1.175 2.825T10 12m0-2q.825 0 1.412-.588Q12 8.826 12 8q0-.824-.588-1.412A1.93 1.93 0 0 0 10 6q-.825 0-1.412.588A1.93 1.93 0 0 0 8 8q0 .825.588 1.412Q9.175 10 10 10m4.65 3.85L17 15.225l2.35-1.375L17 12.5zm3.1 5.2 2.25-1.3V15l-2.25 1.325zM14 17.75l2.25 1.325V16.35L14 15.025z"
    />
  </svg>
);
export default SvgProfilerOutlined;
